import { APP_CONFIG } from '@src/core/config';

export const loadHackSettings = (callback?: () => void) => {
  fetch(APP_CONFIG.baseUrl + '/api/App/settings').then(res =>
    res.json().then(settings => {
      APP_CONFIG.messenger.baseUrl = settings.internalMessengerUrl;
      APP_CONFIG.yandexMetrikaId = settings.yandexMetrikaId || '';
      callback?.();
    }),
  );
};
